module.exports = __webpack_public_path__ + "img/hero.728ff1ae.jpg";